import styles from "./day.module.css";
import { useState, useEffect } from "react";
import { useMeals, useMealsAction } from "../../../Context/MealsProvider";
import eghamat from "assets/image/create-tour/eghamat.svg";
import afternoon from "assets/image/create-tour/afternoon.svg";
import braekfast from "assets/image/create-tour/braekfast.svg";
import dinner from "assets/image/create-tour/dinner.svg";
import lunch from "assets/image/create-tour/lunch.svg";
import morning from "assets/image/create-tour/morning.svg";
import mianvade from "assets/image/create-tour/mianvade.svg";
import night from "assets/image/create-tour/night.svg";
import vehicle from "assets/image/create-tour/vehicle.png";

const Modal = ({ index }) => {
  const dispatch = useMealsAction();

  const meals = useMeals();

  const statusChanger = (id) => {
    dispatch({
      type: "changeHandlerStatus",
      day: index,
      mealId: id,
    });
    dispatch({
      type: "clearPrice",
      dayId: index,
      mealId: id,
    });
    // setIsShow((prevState) => {
    //   return [...prevState, (isShow[id].status = !isShow[id].status)];
    // });
  };

  return (
    <div
      class="modal fade"
      id={`exampleModal-${index}`}
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div className={`modal-body d-flex flex-column  ${styles.mainBox}`}>
            <div
              className={`d-flex flex-row justify-content-around  ${styles.rowItemsBox}`}
            >
              <div
                className={`d-flex flex-column  ${styles.imgPriceBox} ${
                  meals[index][0].status && styles.green
                }`}
                onClick={() => statusChanger(0)}
              >
                <img alt="" src={morning} className={styles.imgBox} />
                <p className={styles.textModal}>{meals[index][0].title}</p>
              </div>
              <div
                className={`d-flex flex-column  ${styles.imgPriceBox} ${
                  meals[index][1].status && styles.green
                }`}
                onClick={() => statusChanger(1)}
              >
                <img alt="" src={braekfast} className={styles.imgBox} />
                <p className={styles.textModal}>{meals[index][1].title}</p>
              </div>
              <div
                className={`d-flex flex-column  ${styles.imgPriceBox} ${
                  meals[index][2].status && styles.green
                }`}
                onClick={() => statusChanger(2)}
              >
                <img alt="" src={lunch} className={styles.imgBox} />
                <p className={styles.textModal}>{meals[index][2].title}</p>
              </div>
            </div>
            <div
              className={`d-flex flex-row justify-content-around  ${styles.rowItemsBox}`}
            >
              <div
                className={`d-flex flex-column  ${styles.imgPriceBox} ${
                  meals[index][3].status && styles.green
                }`}
                onClick={() => statusChanger(3)}
              >
                <img alt="" src={mianvade} className={styles.imgBox2} />
                <p className={styles.textModal}>{meals[index][3].title}</p>
              </div>
              <div
                className={`d-flex flex-column  ${styles.imgPriceBox} ${
                  meals[index][4].status && styles.green
                }`}
                onClick={() => statusChanger(4)}
              >
                <img alt="" src={afternoon} className={styles.imgBox} />
                <p className={styles.textModal}>{meals[index][4].title}</p>
              </div>
              <div
                className={`d-flex flex-column  ${styles.imgPriceBox} ${
                  meals[index][5].status && styles.green
                }`}
                onClick={() => statusChanger(5)}
              >
                <img alt="" src={dinner} className={styles.imgBox} />
                <p className={styles.textModal}>{meals[index][5].title}</p>
              </div>
            </div>
            <div
              className={`d-flex flex-row justify-content-around  ${styles.rowItemsBox}`}
            >
              <div
                className={`d-flex flex-column  ${styles.imgPriceBox} ${
                  meals[index][6].status && styles.green
                }`}
                onClick={() => statusChanger(6)}
              >
                <img alt="" src={eghamat} className={styles.imgBox} />
                <p className={styles.textModal}>{meals[index][6].title}</p>
              </div>
              <div
                onClick={() => statusChanger(7)}
                className={`d-flex flex-column  ${styles.imgPriceBox} ${
                  meals[index][7].status && styles.green
                }`}
              >
                <img alt="" src={night} className={styles.imgBox} />
                <p className={styles.textModal}>{meals[index][7].title}</p>
              </div>
              <div
                onClick={() => statusChanger(8)}
                className={`d-flex flex-column  ${styles.imgPriceBox} ${
                  meals[index][8].status && styles.green
                }`}
              >
                <img alt="" src={vehicle} className={styles.imgBox2} />
                <p className={styles.textModal}>{meals[index][8].title}</p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              بستن
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              // onClick={() => {
              //   const activeItems = [];
              //   for (let index = 0; index < 9; index++) {
              //     if (meals[index][id].status) {
              //       activeItems.push(meals[index][id].id);
              //     }
              //   }
              //   dispatch({
              //     type: "addMealsHandler",
              //     activeItems: activeItems,
              //     day: index,
              //   });
              // }}
            >
              ثبت
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;

/* <button
onClick={() =>
  setIsShow((prevState) => {
    return [
      ...prevState,
      (isShow[3].status = !isShow[3].status),
    ];
  })
}
>
+
</button>
{isShow[3].status && (
<input
  type="text"
  value={meals.price}
  onChange={(e) => onChange(e, meals.id)}
/>
)} */
